import { categories } from '@/mocks/categories';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function WhatIsSection() {
  const sectionReveal = useScrollReveal(0.1);

  return (
    <section ref={sectionReveal.ref} className={`py-20 md:py-28 px-4 md:px-6 bg-background-50 ${sectionReveal.isVisible ? 'scroll-reveal visible' : 'scroll-reveal'}`}>
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-6">
            What Is <span className="italic text-primary-600">Superbuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            Superbuy Spreadsheet is a powerful shopping research tool that helps international buyers
            discover products, compare options, organize their favorite finds, and make smarter
            purchasing decisions. A structured Superbuy Spreadsheet allows shoppers to easily compare
            product categories, price ranges, quality information, QC availability, and community
            recommendations.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {[
            { icon: 'ri-search-line', title: 'Discover Better Products', desc: 'Find trending products from different categories with organized spreadsheet data.' },
            { icon: 'ri-time-line', title: 'Save Research Time', desc: 'Skip endless searching and access organized resources curated by experienced shoppers.' },
            { icon: 'ri-scales-3-line', title: 'Compare Before Buying', desc: 'Review product details, seller ratings, and QC availability before making decisions.' },
            { icon: 'ri-shield-check-line', title: 'Shop With Confidence', desc: 'Learn QC methods, shipping strategies, and safety practices from community experts.' },
          ].map((item, idx) => (
            <div key={item.title} className={`bg-background-100 rounded-2xl p-6 md:p-7 hover:bg-background-200/80 transition-all duration-300 ${sectionReveal.isVisible ? 'animate-fade-in-up' : ''}`} style={{ animationDelay: `${0.15 * idx}s` }}>
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}